module.exports = __webpack_public_path__ + "static/media/Escalier-newnew.dae635dc.glb";